import LockTokens from './lockTokens';

export default LockTokens;



// WEBPACK FOOTER //
// ./src/components/elements/lockTokens/index.js